import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Inventory from "@/pages/Inventory";
import AIScan from "@/pages/AIScan";
import Posts from "@/pages/Posts";
import Bandeja from "@/pages/Bandeja";
import Sales from "@/pages/Sales";
import Conversaciones from "@/pages/Conversaciones";
import Crm from "@/pages/Crm";
import Referrals from "@/pages/Referrals";
import Subscribers from "@/pages/Subscribers";
import PublicProduct from "@/pages/PublicProduct";
import Reportes from "@/pages/Reportes";
import Ajustes from "@/pages/Ajustes";
import Setup from "@/pages/Setup";
import Canales from "@/pages/Canales";
import Auditoria from "@/pages/Auditoria";
import Guia from "@/pages/Guia";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import CatalogPrint from "@/pages/CatalogPrint";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import GlobalHelpTooltip from "@/components/GlobalHelpTooltip";
import EmergentBadgeGate from "@/components/EmergentBadgeGate";
import RouteTitle from "@/components/RouteTitle";
import { Navigate } from "react-router-dom";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <EmergentBadgeGate />
          <RouteTitle />
          <GlobalHelpTooltip />
          <Routes>
            <Route path="/p/:id" element={<PublicProduct />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<Dashboard />} />
              <Route path="/guia" element={<Guia />} />
              <Route path="/inventario" element={<Inventory />} />
              <Route path="/catalogo-imprimible" element={<CatalogPrint />} />
              <Route path="/escanear" element={<AIScan />} />
              <Route path="/publicaciones" element={<Posts />} />
              <Route path="/canales" element={<Canales />} />
              <Route path="/bandeja" element={<Bandeja />} />
              <Route path="/conversaciones" element={<Conversaciones />} />
              <Route path="/crm" element={<Crm />} />
              <Route path="/ventas" element={<Sales />} />
              <Route path="/referidos" element={<Referrals />} />
              <Route path="/suscriptores" element={<Subscribers />} />
              <Route path="/reportes" element={<Reportes />} />
              <Route
                path="/ajustes"
                element={
                  <ProtectedRoute requireAdmin>
                    <Ajustes />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/setup"
                element={
                  <ProtectedRoute requireAdmin>
                    <Setup />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/auditoria"
                element={
                  <ProtectedRoute requireAdmin>
                    <Auditoria />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/sucursales"
                element={<Navigate to="/ajustes?tab=sucursales" replace />}
              />
              <Route
                path="/usuarios"
                element={<Navigate to="/ajustes?tab=usuarios" replace />}
              />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
